import { HisPastOptionsType } from './types';

export const HIS_PAST_OPTIONS: HisPastOptionsType = [
  { id: 'recently_single', title: 'Recently single, still healing' },
  { id: 'one_great_love', title: 'Had one great love he never forgets' },
  { id: 'serial_dater', title: 'Serial dater, always chasing the spark' },
  { id: 'never_in_love', title: 'Never really been in love — yet' },
  { id: 'mysterious', title: `Mysterious... he'll tell you someday` },
];
